import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function MagnifyingGlass({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <MagnifyingGlass.Outline {...props} />
  ) : (
    <MagnifyingGlass.Solid {...props} />
  );
}

MagnifyingGlass.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <circle
          cx="9.76657"
          cy="10.2664"
          r="8.98856"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0183 16.9849L19.5423 20.4997"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

MagnifyingGlass.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
